import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../cn.js';
const toneClass = {
    neutral: 'bg-surface-container-high text-on-surface',
    success: 'bg-secondary-container text-on-secondary-container',
    warning: 'bg-tertiary-fixed text-on-tertiary-fixed',
    danger: 'bg-error-container text-on-error-container',
    info: 'bg-secondary-container text-on-secondary-container',
};
export function Badge({ tone = 'neutral', className, ...rest }) {
    return (_jsx("span", { className: cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', 
        // tone is a typed-union prop — bracket lookup is safe.
        // eslint-disable-next-line security/detect-object-injection
        toneClass[tone], className), ...rest }));
}
//# sourceMappingURL=Badge.js.map